export { getDevicePlatform, isApple, getDeviceCategory, getUserDeviceDetails } from "./device";